import { sllrHttp } from 'http.js';

export const syncProducts = ({ pageId, platform }) => {
  return sllrHttp.post(`/omniMessaging/connect/${platform}`, {
    pageId
  });
};

export const checkConnectedChannels = (payload) => {
  return sllrHttp.get(`/plugins/checkTokens`, payload);
};

export const sendChannelCreditinals = (payload) => {
  return sllrHttp.post(`/omniMessaging/token`, payload);
};

export const disconnectChannel = (platform) => {
  return sllrHttp.delete(`/omniMessaging/tokens/${platform}`);
};
